module.exports = __webpack_public_path__ + "assets/img/title-436d3338.png";